import React from "react";
import { Col, Row } from "react-bootstrap";

const Tab2 = (props)=>{
    const {next,prev} = props;
    return(<>
        <h2>Step 2: Creating Your First Bot</h2>
        <br/>
        <p>For this Quick Start Wizard, we’ll automatically create a simple bot for you. This bot will trade on our Paper exchange, which is completely risk-free and uses virtual funds. The purpose is to let you experience how StockHero monitors the market and executes trades on your behalf. Once you’re comfortable, you can switch to creating bots that run on your live brokerage account</p>
        <br></br>
        <p><b>What is a Paper Brokerage?</b></p>
        <p className="mt-2">A Paper Brokerage is a simulated trading environment that mirrors real-time market movements. Bots running on the Paper exchange do not use real money. They trade with virtual funds instead. You can adjust these virtual funds anytime from the Settings page.</p>
        <br/>
        <ul>
            <li><a  className="qtrblue-btn pointer" onClick={prev}>Previous</a></li>
            <li><a  className="qtrtrans-btn pointer" onClick={next}>Next</a></li>
        </ul>
        
    </>)
}
export default Tab2;